
export function slugify (text) {
    return text.toString().toLowerCase().trim()
      .replace(/\s+/g, '_') // Replace spaces with _
      .replace(/\./g, '_') // Replace . with '_'
      .replace(/\&/g, '_') // Replace & with '_'
      .replace(/[^\w\-]+/g, '_') // Remove all non-word chars
      .replace(/\-/g, '_') // Replace & with '_'
      .replace(/\-\-+/g, '_') // Replace multiple - with single _
}

export function displayError (parent, error) {
  let errorMessage = ''

  if (!error.response.data.error.length) {
    errorMessage = error
  } else {
    for (let i = 0; i < error.response.data.error.length; i++) {
      if (i > 0) {
        errorMessage += '\n'
      }

      errorMessage += error.response.data.error[i]
    }
  }
  parent.$store.commit('push', { msg: errorMessage, color: 'error' })
}

export function redirect (path, windowName = '_blank') {
  /**
   * @param {String} path part of path to add to base url (http://host:port/${path})
   * @param {String} windowName name of the window to open default is '_blank' (new tab)
   */

  if (path[0] == '/') path = path.substring(1, path.length)
  const protocols = window.location.href.split('/')
  const url = `${protocols[0]}//${protocols[2]}/${path}`
  window.open(url, windowName)
}
